import { COLORS } from '@/utils/constants';

import ErrorIcon from '../Icons/ErrorIcon';

type Props = {
  message?: string;
};

const ErrorToast = ({ message }: Props) => {
  return (
    <div className="flex h-[44px] w-[500px] flex-row items-center justify-center gap-x-[10px] border-[1px] border-solid border-redDark bg-redLight">
      <ErrorIcon color={COLORS.redDark} />
      <span className="font-workSans text-[14px] leading-[21px] text-redDark">{message}</span>
    </div>
  );
};

export default ErrorToast;
